import {usePermissions} from '@dms/shared';

import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function FeatureMarketAnalysisSubSection() {
  const [canReadBusinessCase] = usePermissions({permissionKeys: ['businessCaseRead']});

  return (
    <VFKit.SubSection data-testid="feature-market-analysis">
      <VFKit.ShowWhen when={canReadBusinessCase}>
        <VFKit.Suspense>
          <VFKit.FeatureMarketAnalysisWidget />
        </VFKit.Suspense>
      </VFKit.ShowWhen>
    </VFKit.SubSection>
  );
}
